import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import { useAssignRoom } from './use-assign-room';

import type { QueryKey } from '@tanstack/react-query';
import type { IPatientAssignStateChange } from 'infrastructure/interfaces';

export const useUpdateAssigneePatientAssignData = (
  queryKey: QueryKey,
  patientGuid: string,
) => {
  const queryClient = useQueryClient();

  const callBack = useCallback(
    (data: IPatientAssignStateChange) => {
      if (data.patientGuid !== patientGuid) return;

      queryClient.setQueryData<IPatientAssignStateChange>(queryKey, () => data);
    },
    [patientGuid],
  );

  useAssignRoom(callBack);
};
